import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Grid } from 'react-bootstrap';
import { proposalOperations, proposalSelectors } from "./state";
import ModuleHeader from '../../components/ModuleHeader';
import TableTemplate from '../../components/TableTemplate';
import moment from 'moment';

import {
    ERROR,
    EMPTY_COUNT,
    DATE_FORMAT,
    EMPTY_STRING,
    DEFAULT_PAGE_NUM,
    FIRST_INDEX,
    MIN_DB_DATE,
    MAX_DB_DATE,
    DAYS,
    MIN_DB_DATE_EXACT,
    FIELD_STARTDATE,
    FIELD_ENDDATE,
    MAX_DB_DATE_EXACT,
    FIELD_CHECKBOX_INDETERMINATE,
    PROPOSAL_TABLE
} from '../../../utils/constants';
import ProposalModal from './ProposalModal';
import { NEW_PROPOSAL, EDIT_PROPOSAL } from "./routes";
import { isNullOrUndefined } from 'util';
import { ERROR_PROPOSAL_UNCHECK, ERROR_PROPOSAL_DUPLICATE_PARTNER, ERROR_DATE_CONFLICT, ERROR_ORDER_CONFLICT, ERROR_PROPOSAL_UPDATE } from '../../../utils/messages';
import ErrorAlert from '../../components/ErrorAlert';
import SuccessAlert from '../../components/SuccessAlert';
import $ from "jquery";

class Proposal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            size: props.pageSize,
            page: this.props.page,
            toggleModal: false,
            startDate: moment(),
            endDate: moment().add(1, DAYS),
            checkboxItems: [],
            error: [],
            headerError: [],
            headerSuccess: []
        };

        this.toggleModal = this.toggleModal.bind(this)
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        if(EMPTY_COUNT <= this.props.path.indexOf(this.props.location.pathname)){
            this.props.fetchDefault(this.state.size, this.state.page);
        }else{
            this.props.fetchDefault(this.state.size, DEFAULT_PAGE_NUM);
        }
    }

    setRowLines = (rows) => {
        this.setCheckboxIndeterminate(false);
        this.setState({page: DEFAULT_PAGE_NUM, size: rows, checkboxItems: [], headerError: [], headerSuccess: []});
        this.props.fetchDefault(rows, DEFAULT_PAGE_NUM)
    }

    checkIdExist(list, checked){
        return list.some(function(proposal){
            return proposal.proposalId === checked;
        })
    }

    nextPage = () => {
        this.setCheckboxIndeterminate(false);
        this.props.fetchDefault(this.state.size, this.state.page + DEFAULT_PAGE_NUM);
        this.setState({ page: this.state.page + DEFAULT_PAGE_NUM, checkboxItems: [], headerError: [], headerSuccess: [] });
    }

    prevPage = () => {
        this.setCheckboxIndeterminate(false);
        this.props.fetchDefault(this.state.size, this.state.page - DEFAULT_PAGE_NUM);
        this.setState({ page: this.state.page - DEFAULT_PAGE_NUM, checkboxItems: [], headerError: [], headerSuccess: []});
    }

    toggleModal = () => {

        if (EMPTY_COUNT < this.state.checkboxItems.length) {

            if (proposalSelectors.checkPartnerDuplicate(this.props.tableList.filter((item) => FIRST_INDEX <= this.state.checkboxItems.indexOf(item.proposalId)))) {
                this.setState({ headerError: [ERROR_PROPOSAL_DUPLICATE_PARTNER], headerSuccess: [] });
            } else {
                this.setState({ headerError: [], headerSuccess: [] });

                let proposalCheck = this.props.tableList.filter((item) => item.proposalId === this.state.checkboxItems[FIRST_INDEX]);

                let filterStart = this.props.tableList.filter((item) =>
                    proposalCheck[FIRST_INDEX].proposalStartDate === item.proposalStartDate
                    && EMPTY_COUNT <= this.state.checkboxItems.indexOf(item.proposalId)
                );

                let filterEnd = this.props.tableList.filter((item) =>
                    proposalCheck[FIRST_INDEX].proposalEndDate === item.proposalEndDate
                    && EMPTY_COUNT <= this.state.checkboxItems.indexOf(item.proposalId)
                );

                let filterStartDate = MIN_DB_DATE_EXACT;
                let filterEndDate = MAX_DB_DATE_EXACT;

                if (filterStart.length === this.state.checkboxItems.length) {
                    filterStartDate = moment(proposalCheck[FIRST_INDEX].strStartDate).format(DATE_FORMAT);
                }

                if (filterEnd.length === this.state.checkboxItems.length) {
                    filterEndDate = moment(proposalCheck[FIRST_INDEX].strEndDate).format(DATE_FORMAT);
                }

                let toggle = this.state.toggleModal;
                
                this.setState({
                    toggleModal: !toggle,
                    startDate: filterStartDate,
                    endDate: filterEndDate,
                    error: []
                });
            }
        } else {
            this.setState({ headerError: [ERROR_PROPOSAL_UNCHECK], headerSuccess: [] });
        }
    }

    handleCheckboxChange = (event) => {
        this.setState({
            [event.target.name]:
                EMPTY_COUNT <= this.state[event.target.name].indexOf(event.target.value)
                    ? this.state[event.target.name].filter(arr => arr !== event.target.value)
                    : [...this.state[event.target.name], event.target.value]
        }, ()=>{
            let hasSelected = EMPTY_COUNT < this.state.checkboxItems.length && this.props.tableList.length > this.state.checkboxItems.length;

            if(hasSelected){
                this.setCheckboxIndeterminate(true);
            }else{
                this.setCheckboxIndeterminate(false);
            }
        });
    }

    handleMainCheckboxChange = (hasSelected) =>{
        if(hasSelected){
            this.setState({checkboxItems: []});
        }else{
            let newCheckboxItems = this.props.tableList.map((item) => item.proposalId);
            this.setState({checkboxItems: newCheckboxItems});
        }
    }

    setCheckboxIndeterminate(flag){
        let checkbox = $(`#${FIELD_CHECKBOX_INDETERMINATE}`)[FIRST_INDEX];
        checkbox.indeterminate = flag;
    }

    handleDateChangeRaw = (event) => {
        if (EMPTY_STRING !== event.target.value) {
            this.setState({ [event.target.name]: event.target.value })
        } else if (FIELD_STARTDATE === event.target.name) {
            this.setState({ [event.target.name]: MIN_DB_DATE_EXACT })
        } else if (FIELD_ENDDATE === event.target.name) {
            this.setState({ [event.target.name]: MAX_DB_DATE_EXACT })
        }
    }

    handleDateChange = (name, customFormat, date) => {
        if (!isNullOrUndefined(date)) {
            let formatDate = date.format(customFormat)
            this.setState({ [name]: formatDate })
        }
    }

    handleSubmit = () => {

        let errorList  = proposalSelectors.validate(this.state);

        if (EMPTY_COUNT < errorList.length) {
            this.setState({ error: errorList });
        } else {
            let newStartDate = this.state.startDate <= MIN_DB_DATE ? MIN_DB_DATE_EXACT : this.state.startDate;
            let newEndDate = this.state.endDate >= MAX_DB_DATE ? MAX_DB_DATE_EXACT : this.state.endDate;

            this.props.checkDateConflict(this.state.checkboxItems, newStartDate, newEndDate).then((result) => {
                if (result.data && (EMPTY_COUNT < result.data.orders.length || EMPTY_COUNT < result.data.conflicts.length)) {
                    let prompt = [];

                    if(EMPTY_COUNT < result.data.conflicts.length){
                        prompt.push(ERROR_DATE_CONFLICT);
                        result.data.conflicts.map((item) => prompt.push("* " + item.proposalName + " - " + item.customerName));
                        EMPTY_COUNT < result.data.orders.length && prompt.push(EMPTY_STRING);
                    }

                    if(EMPTY_COUNT < result.data.orders.length){
                        prompt.push(ERROR_ORDER_CONFLICT);
                        result.data.orders.map((item) => prompt.push("* 受注番号 " + item));
                    }
                    
                    this.setState({ error: prompt });
                }  else {
                    this.props.updateBulkPeriod(this.state.checkboxItems, newStartDate, newEndDate, this.props.user.user_cd).then((result) => {
                        if (ERROR === result.status) {
                            this.setState({ error: [result.message] });
                        } else {
                            if(null === result.data || EMPTY_COUNT === result.data){
                                this.setState({ error:  [ERROR_PROPOSAL_UPDATE]});
                            }else{
                                this.toggleModal();
                                this.setState({ checkboxItems: [], headerSuccess: [result.data + " レコードは正常に更新されました。"] });
                                this.props.fetchDefault(this.state.size, this.state.page);
                                this.setCheckboxIndeterminate(false);
                            }
                        }
                    }).catch(()=>this.setState({ error:  [ERROR_PROPOSAL_UPDATE]}));
                }
            }).catch(()=>this.setState({ error:  [ERROR_PROPOSAL_UPDATE]}));
        }
    }

    addProposal = () => {
        this.props.history.push(NEW_PROPOSAL);
    }

    editProposal = (row) => {
        this.props.history.push(EDIT_PROPOSAL + "/" + row.proposalId);
    }

    copyProposal = (data) => {
        this.props.history.push({
            pathname: NEW_PROPOSAL,
            state: { copied: data.proposalId }
        });
    }

    errorHeaderAlert = () => {
        if(EMPTY_COUNT < this.state.headerError.length){
            return <ErrorAlert errors={this.state.headerError}/>
        }else{
            return <SuccessAlert success={this.state.headerSuccess}/>
        }
        
    }

    render() {
        return (
            <Grid fluid={true}>
                <Grid>
                    <ModuleHeader
                        title={"商品提案グループ一覧"}
                        size={this.state.size}
                        filter={true}
                        setRowLines={this.setRowLines.bind(this)}
                        nextPage={this.nextPage}
                        prevPage={this.prevPage}
                        maxPage={this.props.pageCount}
                        currPage={this.state.page}
                        withAction={this.errorHeaderAlert()}
                    />

                    <TableTemplate
                        {...this.props}
                        tableName={PROPOSAL_TABLE}
                        checkboxItems={this.state.checkboxItems}
                        handleCheckboxChange={this.handleCheckboxChange}
                        handleMainCheckboxChange={this.handleMainCheckboxChange}
                        proposalRow={{ color: "#ccc" }}
                        rowButtons={[
                            {
                                onClick: this.editProposal,
                                icon: ['far', "edit"],
                                bsStyle: "link"
                            },
                            {
                                onClick: this.copyProposal,
                                icon: ['far', "copy"],
                                bsStyle: "link"
                            }
                        ]}
                    />

                    <center>
                        <Button
                            className="button-common"
                            onClick={() => this.addProposal()}
                        >
                            新規登録
                        </Button>
                        <Button
                            className="button-common"
                            onClick={this.toggleModal}
                        >
                            期間変更
                        </Button>
                    </center>

                    <ProposalModal
                        title={"提案期間一括変更"}
                        showModal={this.state.toggleModal}
                        toggleModal={this.toggleModal}
                        error={this.state.error}
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        handleDateChange={this.handleDateChange}
                        handleSubmit={this.handleSubmit}
                        isChecked={EMPTY_COUNT < this.state.checkboxItems.length}
                        handleDateChangeRaw={this.handleDateChangeRaw}
                    />
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.auth.credentials,
        tableHeader: state.proposal.tableHeader,
        tableColumns: state.proposal.tableColumns,
        tableList: state.proposal.list,
        pageCount: state.proposal.pageCount,
        pageSize: state.proposal.pageSize,
        page: state.bpOrder.page,
        path: state.bpOrder.path
    }
};

const mapDispatchToProps = {
    fetchDefault: proposalOperations.fetchDefault,
    updateBulkPeriod: proposalOperations.updateBulkPeriod,
    checkDateConflict: proposalOperations.checkDateConflict
};

export default connect(mapStateToProps, mapDispatchToProps)(Proposal);